"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const react_router_dom_1 = require("react-router-dom");
const react_modal_1 = __importDefault(require("react-modal"));
const LandingPage_1 = __importDefault(require("./LandingPage"));
const MultiPlayerPage_1 = __importDefault(require("./MultiPlayerPage"));
const SinglePlayerPage_1 = __importDefault(require("./SinglePlayerPage"));
const GamePage_1 = __importDefault(require("./GamePage"));
const LogoPopup_1 = __importDefault(require("./components/LogoPopup"));
const abstract_background_svg_1 = __importDefault(require("!file-loader!../svg/abstract_background.svg"));
react_modal_1.default.setAppElement("#react-root");
const useStyles = (0, react_jss_1.createUseStyles)({
    background: {
        backgroundImage: `url(${abstract_background_svg_1.default})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        overflowY: "auto",
    },
});
const App = () => {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.background },
        react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(LogoPopup_1.default, null),
            react_1.default.createElement(react_router_dom_1.Routes, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(LandingPage_1.default, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/multiplayer", element: react_1.default.createElement(MultiPlayerPage_1.default, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/singleplayer", element: react_1.default.createElement(SinglePlayerPage_1.default, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/game", element: react_1.default.createElement(GamePage_1.default, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/*", element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/" }) })))));
};
exports.default = App;
